import { updateSelectedUser } from "actions/updateSelectedUser";
import { updateUserHistoryFilter } from "actions/updateUserHistoryFilter";
import { IUserStatusViewModel } from "interfaces/models/IUserStatusViewModel";
import { useStateMachine } from "little-state-machine";
import { initialUserHistoryFilter } from "modules/InitialUserHistoryFilter";
import { Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ManageHistoryTemplate = ({ user }: IUserStatusViewModel) => {
  const navigate = useNavigate();

  const { actions } = useStateMachine({
    updateSelectedUser,
    updateUserHistoryFilter
  });

  const handleManageUser = () => {
    actions.updateSelectedUser(user);
    navigate("/manageuser");
  };

  const handleUserHistory = () => {
    actions.updateUserHistoryFilter(initialUserHistoryFilter());
    actions.updateSelectedUser(user);
    navigate("/userhistory");
  };

  return (
    <Col xs="auto" className="d-flex justify-content-center">
      <Button
        data-testid={`btnManageUser:${user.username}`}
        variant="primary"
        className="right-margin-small"
        aria-label={`Manage User for Username: ${user.username}`}
        onClick={handleManageUser}
      >
        Manage
      </Button>
      <Button
        data-testid={`btnUserHistory:${user.username}`}
        variant="primary"
        className="right-margin-small"
        aria-label={`User History for Username: ${user.username}`}
        onClick={handleUserHistory}
      >
        History
      </Button>
    </Col>
  );
};

export default ManageHistoryTemplate;
